const buttonTypeCStyle = {
	color: 'colors.buttonTypeC_default',
	textTransform: 'none',
	textDecoration: 'none',
	'&:hover': {
		color: 'colors.buttonTypeC_hover',
	},
	'&:focus': {
		color: 'colors.buttonTypeC_focus',
	},
};

export const sectionStyles = {
	sectionContainer: {
		display: 'flex',
		flexDirection: { xs: 'column', mobileUi: 'row' },
		gap: { xs: '20px', sm: '10px' },
		justifyContent: { xs: 'none', lg: 'space-between' },
		color: 'colors.text_high',
		alignItems: 'center',
		height: { xs: 'auto', mobileUi: '720px', xxl: '720px' },
	},
	headerStyle: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'left',
		gap: '8px',
		justifyContent: 'center',
		width: { xs: '100%', sm: '60%' },
		paddingRight: { lg: '80px' },
	},
	headerGaps: {
		marginBottom: { xs: '8px', tabletMid: '16px' },
	},
	bringStoriesAliveContainer: {
		display: 'flex',
		width: '100%',
		flexDirection: { xs: 'column', smTab: 'row' },
		gap: { xs: '80px', smTab: '16px' },
		justifyContent: 'space-between',
		position: 'absolute',
		bottom: '64px',
		zIndex: 1,
	},
	contentStyle: {
		width: { xs: '100%', mobileUi: '60%', lg: '60%', xxl: '52%' },
		height: 'auto',
	},
	footerStyle: {
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		justifyContent: 'space-between',
		maxWidth: {
			smTab: '688px',
			tabletMid: '944px',
			lg: '1100px',
			xl: '1232px',
			xxl: '1512px',
		},
		marginX: { xs: '24px', smTab: 'auto' },
		paddingY: '48px',
		gap: '40px',
	},
	buttonTypeBStyles: {
		width: '160px',
		height: '40px',
		textTransform: 'none',
		backgroundColor: 'colors.buttonTypeB_default',
		'&:hover': {
			backgroundColor: 'colors.buttonTypeB_hover',
		},
	},
	buttonTypeCStyles: { ...buttonTypeCStyle },
	footerLogoStyle: {
		display: 'flex',
		gap: '16px',
		alignItems: 'center',
		justifyContent: { xs: 'left', sm: 'center' },
		'& svg': {
			height: '16px',
			width: '16px',
			transition: 'fill 0.3s ease-in-out',
			cursor: 'pointer',
			...buttonTypeCStyle,
		},
	},
};
